export default __webpack_public_path__ + "static/media/logo-ast.c3aba502.png";